import styles from './breakpoints.module.scss';

// parse SASS variables and convert rem to px: "1rem" -> 16
export const XS = 16 * parseFloat(styles.xs);
export const SM = 16 * parseFloat(styles.sm);
export const MD = 16 * parseFloat(styles.md);
export const LG = 16 * parseFloat(styles.lg);
export const XL = 16 * parseFloat(styles.xl);
